"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHistoryEnabled = exports.isHistoryObject = exports.isDLCNetworkDataStoreRequest = exports.isDLCPayloadStoreRequest = exports.Reason = exports.DataLifecycleDestination = exports.DataLifecycleStage = exports.DataLifeCycleRequestType = void 0;
var DataLifeCycleRequestType;
(function (DataLifeCycleRequestType) {
    DataLifeCycleRequestType["STORE"] = "STORE";
    DataLifeCycleRequestType["RECORD_STATE_HISTORY"] = "RECORD_STATE_HISTORY";
    DataLifeCycleRequestType["ACCUMLUATE"] = "ACCUMULATE";
    DataLifeCycleRequestType["PERIODIZE"] = "PERIODIZE";
})(DataLifeCycleRequestType || (exports.DataLifeCycleRequestType = DataLifeCycleRequestType = {}));
var DataLifecycleStage;
(function (DataLifecycleStage) {
    DataLifecycleStage["SHORT"] = "SHORT";
    DataLifecycleStage["MEDIUM"] = "MEDIUM";
    DataLifecycleStage["LONG"] = "LONG";
})(DataLifecycleStage || (exports.DataLifecycleStage = DataLifecycleStage = {}));
var DataLifecycleDestination;
(function (DataLifecycleDestination) {
    DataLifecycleDestination["S3"] = "S3";
    DataLifecycleDestination["S3_Glacier"] = "S3_Glacier";
})(DataLifecycleDestination || (exports.DataLifecycleDestination = DataLifecycleDestination = {}));
var Reason;
(function (Reason) {
    Reason["TTL_EXPIRED"] = "TTL_EXPIRED";
    Reason["DELETED_BY_US"] = "DELETED_BY_US";
    Reason["STATE_HISTORY"] = "STATE_HISTORY";
    Reason["USER_DELETION"] = "USER_DELETION";
    Reason["STORE_PAYLOAD"] = "STORE_PAYLOAD";
    Reason["STORE_NETWORK_DEVICE_DATA"] = "STORE_NETWORK_DEVICE_DATA";
})(Reason || (exports.Reason = Reason = {}));
const isDLCPayloadStoreRequest = (request) => {
    return request.Reason === Reason.STORE_PAYLOAD;
};
exports.isDLCPayloadStoreRequest = isDLCPayloadStoreRequest;
/** WRONGLY TYPED */
const isDLCNetworkDataStoreRequest = (request) => {
    return request.Reason === Reason.STORE_NETWORK_DEVICE_DATA;
};
exports.isDLCNetworkDataStoreRequest = isDLCNetworkDataStoreRequest;
const isHistoryObject = (object) => {
    const po = object;
    return !!po && po.index && po.timestamp !== undefined && po.index instanceof Array && po.timestamp instanceof Array;
};
exports.isHistoryObject = isHistoryObject;
const isHistoryEnabled = (object) => {
    const possibleHistoryEnabldeObject = object;
    return possibleHistoryEnabldeObject.stateHistory !== undefined && (0, exports.isHistoryObject)(possibleHistoryEnabldeObject.stateHistory);
};
exports.isHistoryEnabled = isHistoryEnabled;
